module.exports = __webpack_public_path__ + "media/images/pillar_wholesale-bb33ca26fe91b93332da43a7cd9cf129.jpg";